import { Component, Inject } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { SharedModule } from '../../../_shared/shared.module';

import { Facility } from '../../shared/facility.model';
import { FacilityDetailComponent } from '../../facility-detail/facility-detail.component';

@Component({
  selector: 'app-facility-modal',
  templateUrl: './facility-modal.component.html',
  standalone: true,
  imports: [SharedModule, FacilityDetailComponent],
})
export class FacilityModalComponent {
  constructor(
    private ref: MatDialogRef<FacilityModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) {}

  // @Output() dialogSaved = new EventEmitter<any>(); // avoid closing the dialog

  modalTitle = this.data.title;
  facility: Facility = this.data.obj;
  mode = this.data.params.mode;
  defaultLanguage = this.data.params.defaultLanguage;
  additionalLanguages = this.data.params.additionalLanguages;

  // Referenced from app-facility-detail
  onSavedFacility(facility) {
    // this.dialogSaved.emit(facility); // avoid closing the dialog

    this.ref.close(facility); // close the dialog
  }

  // Referenced from app-facility-detail
  onCanceledFacility() {
    this.close();
  }

  close() {
    this.ref.close();
  }
}
